import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import { message, noticeList } from '@/api/mg';
export default {
  data: function data() {
    return {
      active: 3,
      data: '',
      likedData: '',
      repliedData: '',
      systemData: ''
    };
  },
  created: function created() {
    this.getMessage();
  },
  methods: {
    getNoticeList: function getNoticeList(params) {
      var _this = this;
      noticeList(params).then(function (res) {
        if (res.Code === 0) {
          _this.getMessage();
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    clear: function clear() {
      if (this.likedData.count) {
        this.getNoticeList({
          page: 1,
          perPage: 10,
          'filter[type]': 'liked'
        });
      }
      if (this.repliedData.count) {
        this.getNoticeList({
          page: 1,
          perPage: 10,
          'filter[type]': 'replied'
        });
      }
    },
    getMessage: function getMessage() {
      var _this2 = this;
      message().then(function (res) {
        if (res.Code === 0) {
          var data = res.Data.typeUnreadNotifications;
          // {
          //   "type": "liked",
          //   "count": 1,
          //   "created_at": "2021-09-16T07:36:22.000000Z"
          // },
          // {
          //   "type": "replied",
          //   "count": 1,
          //   "created_at": "2021-09-16T07:36:15.000000Z"
          // }
          data.forEach(function (item) {
            if (item.type === 'liked') {
              _this2.likedData = item;
            }
            if (item.type === 'replied') {
              _this2.repliedData = item;
            }
            if (item.type === 'system') {
              _this2.systemData = item;
            }
          });
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    back: function back() {
      this.$router.back();
    },
    toPage: function toPage(name) {
      this.$router.push({
        path: '/message/detail',
        query: {
          str: name
        }
      });
    },
    tabChange: function tabChange(name, title) {
      console.log(name, title);
    }
  }
};